import { useRef } from "react";
import { motion } from "framer-motion";

export default function MagneticButton({ children, className = "", variant = "primary", as = "button", href, onClick, testId, ...rest }) {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const { left, top, width, height } = el.getBoundingClientRect();
    const x = e.clientX - (left + width / 2);
    const y = e.clientY - (top + height / 2);
    el.style.transform = `translate(${x * 0.25}px, ${y * 0.35}px)`;
  };

  const reset = () => {
    if (ref.current) ref.current.style.transform = "translate(0, 0)";
  };

  const styles =
    variant === "primary"
      ? "bg-copper text-ink hover:bg-copperHover"
      : variant === "ghost"
      ? "border border-copper/40 text-copper hover:border-copper hover:bg-copper/10"
      : "bg-transparent border border-parchment/20 text-parchment hover:border-parchment";

  const Inner = (
    <motion.span
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      data-magnetic
      className={`inline-flex items-center gap-3 px-8 py-4 text-xs uppercase tracking-[0.28em] font-display transition-colors duration-500 will-change-transform ${styles} ${className}`}
    >
      {children}
    </motion.span>
  );

  if (as === "a" || href) {
    return (
      <a href={href} onClick={onClick} data-testid={testId} className="inline-block">
        {Inner}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testId} className="inline-block" {...rest}>
      {Inner}
    </button>
  );
}
